import React from 'react';
import styles from './NavBar.module.scss';
import CurvedIcon from '../../assets/icons/iconComponents2/CurvedIcon';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';
import { IconButton } from '@material-ui/core';
import { generatePath, NavLink, useHistory } from 'react-router-dom';
import { routes } from '../../assets/routes';
import LocalPlayRoundedIcon from '@material-ui/icons/LocalPlayRounded';
import { get_user_info } from '../../helpers/api';
import { Button } from '@mui/material';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import MoodIcon from '@material-ui/icons/Mood';

const NavBar = () => {
  const currentPath = window.location.pathname;
  const history = useHistory();

  return (
    <div className={styles.navBar}>
      <div className={styles.shadow} />
      <nav id={styles.right}>
        <NavLink
          to={routes.HOME}
          onClick={(e) =>
            currentPath === routes.HOME ? e.preventDefault() : null
          }
        >
          <IconButton>
            <HomeRoundedIcon fontSize={'large'} />
          </IconButton>
        </NavLink>
        <NavLink
          to={generatePath(routes.PROFILE, { id: get_user_info()?.id || 0 })}
          onClick={(e) =>
            currentPath === routes.PROFILE ? e.preventDefault() : null
          }
        >
          <IconButton>
            <PersonRoundedIcon fontSize={'large'} />
          </IconButton>
        </NavLink>
      </nav>
      <div className={styles.curved}>
        <CurvedIcon />
        <span />
      </div>
      <nav id={styles.left}>
        <NavLink
          to={routes.GIFT}
          onClick={(e) =>
            currentPath === routes.GIFT ? e.preventDefault() : null
          }
        >
          <IconButton>
            <LocalPlayRoundedIcon fontSize={'large'} />
          </IconButton>
        </NavLink>
        <NavLink
          to={routes.MOOD_TRACKER}
          onClick={(e) =>
            currentPath === routes.MOOD_TRACKER ? e.preventDefault() : null
          }
        >
          <IconButton>
            <MoodIcon fontSize={'large'} />
          </IconButton>
        </NavLink>
      </nav>
      <Button
        solo={true}
        variant="gradient"
        className={styles.bigBtn}
        onClick={() => history.push(routes.GIVE_KUDOS)}
      >
        <AddRoundedIcon fontSize={'large'} />
      </Button>
    </div>
  );
};

NavBar.propTypes = {};

export default NavBar;
